<script lang="ts">
    import AudioButton from "../../utils/AudioButton.svelte";
    import type { Word } from "../../dictionary/Word";
    import { get_host } from "../../settings";
    import { current_dialect, italian_language, is_online } from "../../stores/stores";
    export let word: Word;

    let search_audio_promise = fetch(
        get_host() + `/api/dictionary/word/${word.id}/audio`
    ).catch(
        (r)=>
        {
            $is_online = false;
            throw new Error("No audio or server error");
        }
        ).then((r) => {
            if (r.ok) {
                return r;
            } else {
                throw new Error("No audio or server error");
            }
        })
        .then((r) => r.json())
        .then((r) => r.audio);
</script>

{#await search_audio_promise then audio_path}
    <AudioButton {audio_path} class_list={["right"]} />
{:catch}

{/await}
